export default "__VITE_ASSET__MSRGoq9k__"